import React, { Component } from 'react';
import MediaQuery from 'react-responsive';

import video from '../videos/video.mp4';
import './Header.css';
import { DEVICE_THRESHOLD } from '../index';
import mobileBackground from '../images/bg-mobile.png';

class Header extends Component {
  render() {

    const {
      topOffset,
      height,
    } = this.props;
    return (
      <div id="lp-header" className="lp-header-container">
        <div style={{
          height: topOffset,
        }}/>
        <div className="lp-header-video">
          <MediaQuery minWidth={DEVICE_THRESHOLD + 1}>
            <video
              style={{
                height,
              }}
              preload="none"
              muted
              loop
              autoPlay
            >
              <source src={video} type="video/mp4" />
            </video>
          </MediaQuery>
          <MediaQuery maxWidth={DEVICE_THRESHOLD}>
            <img style={{
              height: height - 120,
            }} src={mobileBackground} alt="Mobile Header" />
          </MediaQuery>
        </div>
        <div
          className="lp-video-filter"
          style={{
            top: topOffset,
          }}
        />
        <div
          className="lp-header-text"
          style={{
            top: topOffset,
          }}
        >
          <MediaQuery minWidth={DEVICE_THRESHOLD + 1}>
            <div className="lp-desktop">Tools and Data from Grab,<br/>built for the OpenStreetMap Community</div>
          </MediaQuery>
          <MediaQuery maxWidth={DEVICE_THRESHOLD}>
            <div className="lp-mobile">Tools and Data from Grab,<br/>built for the OpenStreetMap Community</div>
          </MediaQuery>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js